import { DisplayData, TenantOrderLine } from '~/lib/model';
import Big from 'big.js';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { DeliverableType } from '~common/model/Deliverable';
import MlmFloorplanConfig from './MlmFloorplanConfig';
import MlmJob from '../../model/MlmJob';
import { PersonaType } from '~/tenants/common/TenantPersona';

const MLM_FLOOR_PLAN_MIN_SQFT = 1000;
const MLM_FLOOR_PLAN_MIN_AMOUNT = 100;
const MLM_FLOOR_PLAN_SQFT_MULTIPLIER = 0.025;

export default class MlmFloorplanJob extends MlmJob<typeof MlmFloorplanConfig> {
  defaultValue(): ZodVersionedMetadata<(typeof MlmFloorplanConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
    };
  }

  onsite() {
    return 30;
  }

  get deliverable(): DeliverableType {
    return DeliverableType.FLOORPLAN;
  }

  get media() {
    return PersonaType.OFFICE;
  }

  get performable() {
    return MlmFloorplanConfig;
  }

  info(): DisplayData[] {
    const info = super.info();

    return info;
  }

  expenseLines(): TenantOrderLine[] {
    const lines = super.expenseLines();

    return lines;
  }

  revenueLines(): TenantOrderLine[] {
    const lines = super.revenueLines();

    lines.push({
      amount: new Big(120),
      description: `2D Floorplan`,
      id: 'floorplan',
    });

    return lines;
  }
}
